import React from 'react';
import ColorControls from './colors-controls/colors-controls';
import columns from './columns';
import messages from './messages';
import Breadcrumb from 'components/Common/Breadcrumb';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {Container} from 'reactstrap';
import Table from 'features/table';

const ColorsPage = () => {
  const {t} = useTranslation();

  return (
    <div className="page-content pb-0">
      <Helmet>
        <title> {t(...messages.title())}</title>
      </Helmet>

      <Container fluid>
        <Breadcrumb
          breadcrumbItems={[
            {title: t('common.dashboard'), path: '/dashboard'},
            {title: t(...messages.title()), path: '#'},
          ]}
        />
        <Table
          url="colors"
          otherParams={{
            delimiter: '|',
          }}
          columns={columns}
          filtersComponent={ColorControls}
          name="colors"
        />
      </Container>
    </div>
  );
};

export default ColorsPage;
